import quickSpecs from './quickSpecs';
import vehicleType from './vehicleType';
import attributesFromIDC from './attributesFromIDC';
import isElectric from './isElectric';
import vehicle from './vehicle';
import siteInfo from './siteInfo';

const root = {
	quickSpecs,
	vehicleType,
	attributesFromIDC,
	isElectric,
	vehicle,
	siteInfo
};

export default root;
